import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { organizationMemberProfileQueryKeys } from './organizationMemberProfile.queryKeys';
import { organizationMembersQueryKeys } from './organizationMembers.queryKeys';
import { organizationClientsQueryKeys } from './organizationClients.queryKeys';
import { staffHomeQueryKeys } from './staffHome.queryKeys';
import { dayNoteQueryKeys } from './dayNote.queryKeys';
import { trainerSessionsQueryKeys } from './trainerSessions.queryKeys';
import { healthHoldQueryKeys } from './healthHold.queryKeys';
import { deskQueryKeys } from './desk.queryKeys';
import { lockerKeysQueryKeys } from './lockerKeys.queryKeys';
import { staffBusinessOverviewQueryKeys } from './staffBusinessOverview.queryKeys';
import { performanceStatsQueryKeys } from './performanceStats.queryKeys';
import { trainerEarningsQueryKeys } from './trainerEarnings.queryKeys';
import { marketplacePaymentsQueryKeys } from './marketplacePayments.queryKeys';
import { paymentRefundsQueryKeys } from './paymentRefunds.queryKeys';
import { statsProgressPhotosQueryKeys } from './statsProgressPhotos.queryKeys';
import { notificationCenterQueryKeys } from './notificationCenter.queryKeys';
import { statsHealthProfileQueryKeys } from './statsHealthProfile.queryKeys';
import { scheduleNutritionQueryKeys } from './scheduleNutrition.queryKeys';
import { corpOrganizationsQueryKeys } from './corpOrganizations.queryKeys';
import { statsMeasurementsQueryKeys } from './statsMeasurements.queryKeys';
import { statsFitnessScoreQueryKeys } from './statsFitnessScore.queryKeys';
import { statsActivityLogQueryKeys } from './statsActivityLog.queryKeys';
import { privacyPoliciesQueryKeys } from './privacyPolicies.queryKeys';
import { platformBillingQueryKeys } from './platformBilling.queryKeys';
import { accountBillingQueryKeys } from './accountBilling.queryKeys';
import { statsNutritionQueryKeys } from './statsNutrition.queryKeys';
import { questionnaireSubmissionsQueryKeys } from './questionnaireSubmissions.queryKeys';
import { questionnairesQueryKeys } from './questionnaires.queryKeys';
import { recentlyViewedQueryKeys } from './recentlyViewed.queryKeys';
import { nutritionPlansQueryKeys } from './nutritionPlans.queryKeys';
import { configurablesQueryKeys } from './configurables.queryKeys';
import { conversationsQueryKeys } from './conversations.queryKeys';
import { notificationsQueryKeys } from './notifications.queryKeys';
import { statsRegistryQueryKeys } from './statsRegistry.queryKeys';
import { statsPlatformQueryKeys } from './statsPlatform.queryKeys';
import { corpoStatsQueryKeys } from './corpoStats.queryKeys';
import { organizationsQueryKeys } from './organization.queryKeys';
import { clientGroupsQueryKeys } from './clientGroups.queryKeys';
import { bookingEventTemplatesQueryKeys } from './bookingEventTemplates.queryKeys';
import { bookingEventsQueryKeys } from './bookingEvents.queryKeys';
import { bookingStatsQueryKeys } from './bookingStats.queryKeys';
import { bookingsQueryKeys } from './bookings.queryKeys';
import { scheduleQuestionnaireQueryKeys } from './scheduleQuestionnaire.queryKeys';
import { scheduleSearchQueryKeys } from './scheduleSearch.queryKeys';
import { scheduleNoteQueryKeys } from './scheduleNote.queryKeys';
import { healthIssuesQueryKeys } from './healthIssues.queryKeys';
import { userDocumentQueryKeys } from './userDocument.queryKeys';
import { financeEntriesQueryKeys } from './financeEntries.queryKeys';
import { financeStatsQueryKeys } from './financeStats.queryKeys';
import { statsPrivacyQueryKeys } from './statsPrivacy.queryKeys';
import { membershipsQueryKeys } from './memberships.queryKeys';
import { marketplaceAccessQueryKeys } from './marketplaceAccess.queryKeys';
import { marketplaceQueryKeys } from './marketplace.queryKeys';
import { categoriesQueryKeys } from './categories.queryKeys';
import { invitationQueryKeys } from './invitation.queryKeys';
import { statsQueryQueryKeys } from './statsQuery.queryKeys';
import { statsGoalsQueryKeys } from './statsGoals.queryKeys';
import { corpCodesQueryKeys } from './corpCodes.queryKeys';
import { groceriesQueryKeys } from './groceries.queryKeys';
import { exercisesQueryKeys } from './exercises.queryKeys';
import { statsBodyQueryKeys } from './statsBody.queryKeys';
import { episodesQueryKeys } from './episodes.queryKeys';
import { trainersQueryKeys } from './trainers.queryKeys';
import { workoutsQueryKeys } from './workouts.queryKeys';
import { programsQueryKeys } from './programs.queryKeys';
import { scheduleQueryKeys } from './schedule.queryKeys';
import { progressQueryKeys } from './progress.queryKeys';
import { statsKpiQueryKeys } from './statsKpi.queryKeys';
import { modulesQueryKeys } from './modules.queryKeys';
import { coursesQueryKeys } from './courses.queryKeys';
import { libraryQueryKeys } from './library.queryKeys';
import { premiumQueryKeys } from './premium.queryKeys';
import { premiumContentQueryKeys } from './premiumContent.queryKeys';
import { tenantsQueryKeys } from './tenant.queryKeys';
import { walletQueryKeys } from './wallet.queryKeys';
import { mealsQueryKeys } from './meals.queryKeys';
import { goalsQueryKeys } from './goals.queryKeys';
import { usersQueryKeys } from './users.queryKeys';
import { contentCopyQueryKeys } from './contentCopy.queryKeys';
import { publicSiteQueryKeys } from './publicSite.queryKeys';
import { publicPageAdminQueryKeys } from './publicPageAdmin.queryKeys';
import { publicPageQueryKeys } from './publicPage.queryKeys';
import { rolesQueryKeys } from './roles.queryKeys';
import { tagsQueryKeys } from './tags.queryKeys';
import { termsOfUseQueryKeys } from './termsOfUse.queryKeys';
import { membershipTermsOfUseQueryKeys } from './membershipTermsOfUse.queryKeys';
import { prospectsQueryKeys } from './prospects.queryKeys';
// my-api/index.ts
// mergeQueryKeys over ~45 stores breaks TS inference (depth limit) → two
// smaller merges joined with a spread; the public shape of `queryKeys` is
// unchanged.
const coreQueryKeys = mergeQueryKeys(
  nutritionPlansQueryKeys,
  groceriesQueryKeys,
  mealsQueryKeys,
  tenantsQueryKeys,
  usersQueryKeys,
  organizationsQueryKeys,
  corpOrganizationsQueryKeys,
  corpCodesQueryKeys,
  rolesQueryKeys,
  trainersQueryKeys,
  configurablesQueryKeys,
  categoriesQueryKeys,
  tagsQueryKeys,
  privacyPoliciesQueryKeys,
  exercisesQueryKeys,
  episodesQueryKeys,
  modulesQueryKeys,
  coursesQueryKeys,
  workoutsQueryKeys,
  programsQueryKeys,
  scheduleQueryKeys,
  marketplaceAccessQueryKeys,
  marketplaceQueryKeys,
  libraryQueryKeys,
  healthIssuesQueryKeys,
  goalsQueryKeys,
  invitationQueryKeys,
  conversationsQueryKeys,
  progressQueryKeys,
  notificationsQueryKeys,
  notificationCenterQueryKeys,
  scheduleNoteQueryKeys,
  scheduleNutritionQueryKeys,
  recentlyViewedQueryKeys,
  membershipsQueryKeys,
  clientGroupsQueryKeys,
  organizationClientsQueryKeys,
  organizationMembersQueryKeys,
  organizationMemberProfileQueryKeys,
  userDocumentQueryKeys,
  questionnairesQueryKeys,
);

// Billing/finance stores split out of `coreQueryKeys` — same TS inference
// depth limit the split above works around; keep new billing-related stores here.
const billingDomainQueryKeys = mergeQueryKeys(
  walletQueryKeys,
  platformBillingQueryKeys,
  premiumQueryKeys,
  premiumContentQueryKeys,
  financeStatsQueryKeys,
  marketplacePaymentsQueryKeys,
  paymentRefundsQueryKeys,
  accountBillingQueryKeys,
);

// WS2 — merged separately: adding a 46th store to `coreQueryKeys` trips the
// same TS inference depth limit the split above works around.
const contentCopyDomainQueryKeys = mergeQueryKeys(contentCopyQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const questionnaireSubmissionsDomainQueryKeys = mergeQueryKeys(
  questionnaireSubmissionsQueryKeys,
);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const scheduleQuestionnaireDomainQueryKeys = mergeQueryKeys(
  scheduleQuestionnaireQueryKeys,
);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const scheduleSearchDomainQueryKeys = mergeQueryKeys(scheduleSearchQueryKeys);

// Task 13 (public page): `coreQueryKeys` is already at the 45-store limit
// above (see WS2 comment) — merged separately for the same reason.
const publicPageDomainQueryKeys = mergeQueryKeys(publicPageQueryKeys);

// Task 16 (public page, anonymous FE): same 45-store limit, same reason —
// its own bucket rather than joining `publicPageDomainQueryKeys` (a
// different domain: authenticated editing vs. the anonymous read route).
const publicSiteDomainQueryKeys = mergeQueryKeys(publicSiteQueryKeys);

// Task 19 (public page admin/takedown): same 45-store limit, same reason —
// its own bucket, a third distinct domain (platform admin vs. authenticated
// editing vs. anonymous read).
const publicPageAdminDomainQueryKeys = mergeQueryKeys(publicPageAdminQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const termsOfUseDomainQueryKeys = mergeQueryKeys(termsOfUseQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const membershipTermsOfUseDomainQueryKeys = mergeQueryKeys(
  membershipTermsOfUseQueryKeys,
);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const prospectsDomainQueryKeys = mergeQueryKeys(prospectsQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const staffHomeDomainQueryKeys = mergeQueryKeys(staffHomeQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const dayNoteDomainQueryKeys = mergeQueryKeys(dayNoteQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const trainerSessionsDomainQueryKeys = mergeQueryKeys(trainerSessionsQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const healthHoldDomainQueryKeys = mergeQueryKeys(healthHoldQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const deskDomainQueryKeys = mergeQueryKeys(deskQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const lockerKeysDomainQueryKeys = mergeQueryKeys(lockerKeysQueryKeys);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `coreQueryKeys`.
const staffBusinessOverviewDomainQueryKeys = mergeQueryKeys(
  staffBusinessOverviewQueryKeys,
);

// Same depth-limit workaround as above — kept as its own merge rather than
// added to `statsDomainQueryKeys`, which is already at the limit.
const performanceStatsDomainQueryKeys = mergeQueryKeys(
  performanceStatsQueryKeys,
);

// MV2-577 Part 2 — same depth-limit workaround as above, its own group.
const trainerEarningsDomainQueryKeys = mergeQueryKeys(trainerEarningsQueryKeys);

const statsDomainQueryKeys = mergeQueryKeys(
  statsRegistryQueryKeys,
  statsMeasurementsQueryKeys,
  statsQueryQueryKeys,
  statsKpiQueryKeys,
  statsBodyQueryKeys,
  statsHealthProfileQueryKeys,
  statsActivityLogQueryKeys,
  statsProgressPhotosQueryKeys,
  statsNutritionQueryKeys,
  statsGoalsQueryKeys,
  statsFitnessScoreQueryKeys,
  statsPlatformQueryKeys,
  statsPrivacyQueryKeys,
  corpoStatsQueryKeys,
  // T17 — manual finance entries and the monthly net result. Same domain as
  // `financeStats` but merged here, not into `billingDomainQueryKeys`: that
  // merge is at TypeScript's instantiation-depth limit, and one more member
  // tips it into TS2589 (the reason every group below exists).
  financeEntriesQueryKeys,
);

// Its own group rather than another entry in `coreQueryKeys`: that merge is
// already at TypeScript's instantiation-depth limit, and one more member tips it
// into TS2589. Same reason the stats/public-page groups are split out.
const bookingDomainQueryKeys = mergeQueryKeys(
  bookingEventsQueryKeys,
  bookingsQueryKeys,
  bookingEventTemplatesQueryKeys,
  bookingStatsQueryKeys,
);

export const queryKeys = {
  ...coreQueryKeys,
  ...bookingDomainQueryKeys,
  ...billingDomainQueryKeys,
  ...statsDomainQueryKeys,
  ...contentCopyDomainQueryKeys,
  ...questionnaireSubmissionsDomainQueryKeys,
  ...scheduleQuestionnaireDomainQueryKeys,
  ...scheduleSearchDomainQueryKeys,
  ...publicPageDomainQueryKeys,
  ...publicSiteDomainQueryKeys,
  ...publicPageAdminDomainQueryKeys,
  ...termsOfUseDomainQueryKeys,
  ...membershipTermsOfUseDomainQueryKeys,
  ...prospectsDomainQueryKeys,
  ...staffHomeDomainQueryKeys,
  ...dayNoteDomainQueryKeys,
  ...trainerSessionsDomainQueryKeys,
  ...healthHoldDomainQueryKeys,
  ...deskDomainQueryKeys,
  ...lockerKeysDomainQueryKeys,
  ...staffBusinessOverviewDomainQueryKeys,
  ...performanceStatsDomainQueryKeys,
  ...trainerEarningsDomainQueryKeys,
};
